module.exports = __webpack_public_path__ + "static/img/AB4338772.2a3ada32.jpg";